import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export default function CopyItineraryModal({ show, onHide, shareId }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleCopyId = () => {
    if (shareId) {
      navigator.clipboard.writeText(shareId).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }).catch(err => {
        console.error('Failed to copy:', err);
      });
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('planDetailShare.copyItinerary.title', { defaultValue: 'Copy Itinerary' })}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t('planDetailShare.copyItinerary.description', { defaultValue: 'To copy this itinerary to your own account, follow these steps:' })}</p>
        
        <ol>
          <li className="mb-2">
            {t('planDetailShare.copyItinerary.step1', { defaultValue: 'Copy the Plan ID below' })}
          </li>
          <li className="mb-2">
            {t('planDetailShare.copyItinerary.step2Prefix', { defaultValue: 'Login or create an account at ' })}
            <a href="https://trip147.com" target="_blank" rel="noopener noreferrer">trip147.com</a>
          </li>
          <li className="mb-2">
            {t('planDetailShare.copyItinerary.step3', { defaultValue: 'Go to the Copy Itinerary page and paste the Plan ID' })}
          </li>
        </ol>

        <div className="mb-3">
          <Form.Label className="fw-bold">
            {t('planDetailShare.copyItinerary.planId', { defaultValue: 'Plan ID:' })}
          </Form.Label>
          <div className="d-flex gap-2">
            <Form.Control
              type="text"
              value={shareId || ''}
              readOnly
              className="font-monospace"
            />
            <Button
              variant={copied ? 'success' : 'outline-primary'}
              onClick={handleCopyId}
              size="sm"
            >
              {copied ? (
                <>
                  <i className="bi bi-check-circle me-1"></i>
                  {t('planDetailShare.copyItinerary.copied', { defaultValue: 'Copied!' })}
                </>
              ) : (
                <>
                  <i className="bi bi-clipboard me-1"></i>
                  {t('planDetailShare.copyItinerary.copy', { defaultValue: 'Copy' })}
                </>
              )}
            </Button>
          </div>
        </div>

      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('planDetailShare.copyItinerary.close', { defaultValue: 'Close' })}
        </Button>
        <Button 
          variant="primary" 
          onClick={() => {
            window.location.href = '/copy-itinerary';
          }}
        >
          {t('planDetailShare.copyItinerary.goToPage', { defaultValue: 'Go to Copy Itinerary Page' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
